"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * class used for automatically refresh the token.
 * the refreshtoken method is auomatically triggered in case the user interacted with the page within the last 15 minutes before token expiration
 */
/**
 * auto refresh minutes interval
 */
var CONSIDER_INTERACTION_MINUTES_INTERVAL = 15;
var ONE_MIN_MS = 60000;
var USER_INTERACTION_EVENTS = ['keyup', 'mousemove'];
var TokenAutoRefresh = /** @class */ (function () {
    function TokenAutoRefresh() {
        var _this = this;
        /**
         * Handler for user interactions
         * Initiates the Token Refresh one minute before it expires, if any interaction is detected
         * Returns immediately if the refresh is already scheduled
         * @returns
         */
        this.userInteractionHandler = function () {
            var _a, _b;
            if (!((_a = _this.refreshParameters) === null || _a === void 0 ? void 0 : _a.expire) || !_this.refreshParameters.refreshTokenMethod) {
                return;
            }
            if (_this.refreshState === 'in-progress') {
                return;
            }
            _this.refreshState = 'in-progress';
            var interval = _this.fromNowToNMinutesBeforeDate((_b = _this.refreshParameters) === null || _b === void 0 ? void 0 : _b.expire, 1);
            setTimeout(function () { var _a; return (_a = _this.refreshParameters) === null || _a === void 0 ? void 0 : _a.refreshTokenMethod(); }, interval);
        };
        /**
        * Initializes the event listeners for user interaction
        * The function passed must be the member bound to this instance
        */
        this.initializeDomEvents = function () {
            USER_INTERACTION_EVENTS.forEach(function (eventName) { return window.addEventListener(eventName, _this.userInteractionHandler); });
        };
        /**
         * Clears event listeners
         */
        this.clearDomEvents = function () {
            USER_INTERACTION_EVENTS.forEach(function (eventName) { return window.removeEventListener(eventName, _this.userInteractionHandler); });
        };
    }
    /**
     * starts the autorefresh flow
     * @param autoRefreshParameters {@link ITokenAutoRefreshParams} parameters used for auto refresh flow
     */
    TokenAutoRefresh.prototype.startAutoRefreshFlow = function (autoRefreshParameters) {
        var _this = this;
        if (!autoRefreshParameters || !autoRefreshParameters.expire || !autoRefreshParameters.refreshTokenMethod) {
            return;
        }
        this.refreshParameters = autoRefreshParameters;
        this.refreshState = 'idle';
        if (this.ignoreUserInteractionTimerId) {
            clearTimeout(this.ignoreUserInteractionTimerId);
        }
        this.clearDomEvents();
        var ignoreUserInteractionTime = this.fromNowToNMinutesBeforeDate(this.refreshParameters.expire, CONSIDER_INTERACTION_MINUTES_INTERVAL);
        this.ignoreUserInteractionTimerId = setTimeout(function () {
            _this.initializeDomEvents();
        }, ignoreUserInteractionTime);
    };
    /**
     * Returns the milliseconds interval from now to a given date minus N minutes
     * @param toDate represents the target date
     * @param nMinutes represents the number of minutes to substract from the target date
     * @returns the interval in milliseconds; if the resulting interval is a negative number,
     * this method returns 100ms
     */
    TokenAutoRefresh.prototype.fromNowToNMinutesBeforeDate = function (toDate, nMinutes) {
        var interval = toDate.getTime() - new Date().getTime() - nMinutes * ONE_MIN_MS;
        if (interval < 0) {
            return 100;
        }
        return interval;
    };
    return TokenAutoRefresh;
}());
exports.default = new TokenAutoRefresh();
